/* eslint-disable no-unused-vars */
import { useState, useEffect } from "react";

import PropTypes from "prop-types";

import { Button, Form, Input, InputNumber, Modal } from "antd";
import { useTranslation } from "react-i18next";
import { useToast } from "../../../../contexts/ToastContext";

import { getStatus } from "../../../dashboard/components/formatReservations";
import apiClient from "../../../../helpers/apiClient";
import customizeRequiredMark from "../../../../components/custom_antd/CustomizeRequiredMark";

const ExtraChargeModal = ({
    match,
    overDueModalClose,
    customerDetails,
    resDetails,
    refetch,
    isOpen,
    editingCharge,
}) => {
    const toast = useToast();
    const [loading, setLoading] = useState(false);
    const { t } = useTranslation(["reservations"]);

    const [form] = Form.useForm();

    // Optional: Set initial values if needed
    useEffect(() => {
        form.setFieldsValue({
            amount: 0,
            description: "",
            customerID: resDetails?.stripeCustomerID,
        });
    }, [form, resDetails]);

    // Editing pre-fills the form with the charge being changed; adding starts blank.
    useEffect(() => {
        if (!isOpen) return;
        if (editingCharge) {
            form.setFieldsValue({
                categoryType: editingCharge.description,
                amount: Number(editingCharge.total),
            });
        } else {
            form.resetFields(["categoryType", "amount"]);
        }
    }, [isOpen, editingCharge, form]);

    // FUNCTIONS

    const ManagePayment = async (values, resetForm) => {
        try {
            setLoading(true);

            const reservationStatus = getStatus(resDetails);

            const invoice = resDetails.invoice || {};
            const charges = [...(invoice?.charges || [])];

            const newCharge = {
                description: values.categoryType,
                unit: 1,
                rate: values.amount,
                total: values.amount,
                type: "extraCharge",
            };

            if (editingCharge) {
                // Charges have no id, so the card hands us the charge's position in the invoice.
                const existing = charges[editingCharge.index];
                if (!existing || existing.type !== "extraCharge") {
                    throw new Error("charge not found");
                }
                charges[editingCharge.index] = { ...existing, ...newCharge };
            } else {
                charges.push(newCharge);
            }

            if (reservationStatus === "upcoming" || reservationStatus === "ongoing") {
                // Handle upcoming reservation - preserve full invoice, only update charges
                await apiClient.patch(`/api/reservation/${resDetails.id}`, {
                    invoice: {
                        ...invoice,
                        charges,
                    },
                });
            } else if (reservationStatus === "completed") {
                toast.error({
                    message: t("payment.reservationCompletedNoExtraCharge"),
                });
                throw new Error("completed");
            }

            toast.success({
                message: editingCharge ? t("payment.extraChargeUpdated") : t("payment.extraChargeAdded"),
            });

            resetForm();
            refetch();
        } catch (_error) {
            if (_error?.message !== "completed") {
                toast.error({
                    message: t("payment.failedToSaveExtraCharge"),
                });
            }
            throw _error;
        } finally {
            setLoading(false);
        }

        // try {

        //   // baseInvoice.push({
        //   //   current: true,
        //   //   charge: am,
        //   //   total: am,
        //   //   description: extraCat,
        //   //   isExtraCharge: true,
        //   // });
        //   // let extraCharge = resDetails.extraCharge || [];
        //   // const newExtraCharge = {
        //   //   current: true,
        //   //   charge: am,
        //   //   total: am,
        //   //   category: extraCat,
        //   //   description: desc,
        //   //   paymentIntentId: "",
        //   // };
        //   // extraCharge.push(newExtraCharge);

        //   // const totalAmount =
        //   //   baseInvoice?.reduce((n, { total }) => n + total, 0) -
        //   //   (resDetails?.discount?.amount || 0);
        //   // taxInvoice = taxInvoice.map((tax) => {
        //   //   const val = tax.charge;
        //   //   const type = tax.taxType;
        //   //   let taxAmount = 0;
        //   //   if (type === "%") {
        //   //     taxAmount = (totalAmount * val) / 100;
        //   //   } else {
        //   //     taxAmount = val;
        //   //   }
        //   //   return {
        //   //     ...tax,
        //   //     total: taxAmount,
        //   //   };
        //   // });
        //   invoice = [...baseInvoice, ...taxInvoice];

        //   // const newAmount = invoice?.reduce((n, { total }) => n + (total || 0), 0);
        //   // const chargeAmount = newAmount - resDetails.amount;

        //   // console.log("newAmount :", newAmount);
        //   // console.log("old amount :", resDetails.amount);
        //   // console.log("diff amount :", chargeAmount);
        //   // console.log("new invoice  :", invoice);

        //   if (resDetails.isPaid) {
        //     // const payload = {
        //     //   amount: Number((chargeAmount * 100).toFixed()),
        //     //   description: `${values.description} with addiotional tax.`,
        //     //   customerID: resDetails.stripeCustomerID,
        //     // };
        //     // payload.customerID = resDetails?.stripeCustomerID;
        //     // if (!payload.customerID) {
        //     //   console.error("payment error : no stripe customerID");
        //     //   await Swal.fire({
        //     //     icon: "error",
        //     //     title: "Failed to make payment",
        //     //     showConfirmButton: true,
        //     //     allowOutsideClick: false,
        //     //   });
        //     //   return;
        //     // }

        //     // console.log("payload :", payload);

        //     let paymentIntentResult;
        //     try {
        //       paymentIntentResult = await apiClient.post(
        //         "/api/payment/charge-overdues",
        //         // payload,
        //         {
        //           headers: {
        //             "company-id": state?.user?.companyId,
        //           },
        //         }
        //       );
        //     } catch (error) {
        //       console.log(error.response);
        //       throw new Error(error);
        //     }
        //     const paymentIntentData =
        //       paymentIntentResult.data?.data?.paymentIntent || "";
        //     console.log("data :", paymentIntentData);
        //     invoice = invoice
        //       .map((item) =>
        //         item.current
        //           ? {
        //               ...item,
        //               paymentIntentId: paymentIntentData.id,
        //             }
        //           : item
        //       )
        //       .map(({ current, ...rest }) => rest);
        //     extraCharge = extraCharge
        //       .map((item) =>
        //         item.current
        //           ? {
        //               ...item,
        //               paymentIntentId: paymentIntentData.id,
        //             }
        //           : item
        //       )
        //       .map(({ current, ...rest }) => rest);
        //   }

        //   // console.log(invoice, extraCharge);
        //   const updateReservationInvoiceResult = await apiClient.patch(
        //     `/api/${resDetails.flag ? "reservation" : "past-reservation"}/${
        //       resDetails.id
        //     }`
        //     // { invoice, extraCharge, amount: newAmount }
        //   );
        //   if (updateReservationInvoiceResult?.data?.success) {
        //     Swal.fire({
        //       title: "Extra charge added!",
        //       icon: "success",
        //     });
        //     refetch();
        //   }

        //   overDueModalClose();
        //   setExtraCat();
        //   resetForm();
        // } catch (error) {
        //   console.error("Error :", error?.response || error);
        //   setLoading(false);
        //   Swal.fire({
        //     icon: "error",
        //     title: "Failed to save extra charge",
        //     timer: 2000,
        //   });
        // }
    };

    const handleFinish = async (values) => {
        try {
            await ManagePayment(values, () => form.resetFields());
            overDueModalClose();
        } catch {
            // errors surfaced via toast in ManagePayment
        }
    };

    return (
        <Modal
            title={
                <div className="text-gray-900 text-lg font-semibold">
                    {editingCharge ? t("payment.editExtraCharge") : t("payment.extraCharge")}
                </div>
            }
            open={isOpen}
            onCancel={overDueModalClose}
            footer={null}
            centered
            width={700}>
            <div className="text-gray-500 text-sm mb-6">{t("payment.managingOutstandingCharges")}</div>

            <Form layout="vertical" form={form} onFinish={handleFinish} requiredMark={customizeRequiredMark}>
                <Form.Item
                    label={t("payment.description")}
                    name="categoryType"
                    rules={[
                        { required: true, message: t("payment.pleaseSelectCategory") },
                        { max: 50, message: t("payment.categoryMaxLength") || "Maximum 50 characters allowed" },
                    ]}>
                    <Input placeholder="e.g. Overdue, Tolls, Gas, Traffic Tickets, Others" maxLength={50} showCount />
                </Form.Item>

                <Form.Item
                    label={t("payment.amountInUSD")}
                    name="amount"
                    rules={[
                        {
                            required: true,
                            message: t("payment.amountRequired"),
                        },
                        {
                            validator: (_, value) =>
                                value && Number(value) > 0
                                    ? Promise.resolve()
                                    : Promise.reject(t("payment.amountPositive")),
                        },
                    ]}>
                    <InputNumber className="w-full" min={0} placeholder={t("payment.enterAmount")} />
                </Form.Item>

                {/* <Form.Item
          label="Description"
          name="description"
          rules={[
            { required: true, message: t("payment.pleaseEnterDescription") },
          ]}
        >
          <TextArea rows={5} className="rounded-md" />
        </Form.Item> */}

                <div className="flex justify-end">
                    <Button type="primary" htmlType="submit" loading={loading} className="bg-blue-600 hover:bg-blue-700">
                        {editingCharge ? t("payment.saveChanges") : t("payment.chargeOverdue")}
                    </Button>
                </div>
            </Form>
        </Modal>
    );
};

ExtraChargeModal.propTypes = {
    match: PropTypes.string,
    overDueModalClose: PropTypes.func,
    customerDetails: PropTypes.object,
    resDetails: PropTypes.object,
    refetch: PropTypes.func,
    isOpen: PropTypes.bool,
    editingCharge: PropTypes.shape({
        index: PropTypes.number.isRequired,
        description: PropTypes.string,
        total: PropTypes.number,
    }),
};

ExtraChargeModal.defaultProps = {
    editingCharge: null,
};

export default ExtraChargeModal;
